import Field, { useFieldError } from "./form/Field";

const grades = Array.from({ length: 12 }, (_, i) => {
  const n = i + 1;
  const suffix = n === 1 ? "st" : n === 2 ? "nd" : n === 3 ? "rd" : "th";
  return { value: `Grade ${n}`, label: `${n}${suffix} grade` };
});

const shirtSizes = ["Adult S", "Adult M", "Adult L", "Adult XL"].map((s) => ({
  value: s,
  label: s,
}));

export default function CamperInfoSection({ section_number, onRemove }) {
  const prefix = `campersInformation[${section_number}]`;
  const required = { required: true };
  const dobErrors = [
    useFieldError(`${prefix}.month`),
    useFieldError(`${prefix}.day`),
    useFieldError(`${prefix}.year`),
  ];

  return (
    <fieldset className="reg-camper">
      <legend>Camper {section_number + 1}</legend>
      {onRemove && (
        <button
          type="button"
          className="reg-link reg-camper__remove"
          onClick={onRemove}
        >
          Remove this camper
        </button>
      )}

      <div className="reg-grid">
        <Field
          name={`${prefix}.firstName`}
          label="First name"
          autoComplete="off"
          rules={{ ...required, maxLength: 20 }}
        />
        <Field
          name={`${prefix}.lastName`}
          label="Last name"
          autoComplete="off"
          rules={{ ...required, maxLength: 20 }}
        />
      </div>

      <div className="reg-field" role="group" aria-labelledby={`dob-${section_number}`}>
        <span className="reg-label" id={`dob-${section_number}`}>
          Date of birth
        </span>
        <div className="reg-dob">
          <Field
            name={`${prefix}.month`}
            label="Month"
            type="number"
            inputMode="numeric"
            placeholder="MM"
            className="reg-field--sub"
            hideError
            rules={{ ...required, maxLength: 2, min: 1, max: 12 }}
          />
          <Field
            name={`${prefix}.day`}
            label="Day"
            type="number"
            inputMode="numeric"
            placeholder="DD"
            className="reg-field--sub"
            hideError
            rules={{ ...required, maxLength: 2, min: 1, max: 31 }}
          />
          <Field
            name={`${prefix}.year`}
            label="Year"
            type="number"
            inputMode="numeric"
            placeholder="YYYY"
            className="reg-field--sub"
            hideError
            rules={{
              ...required,
              maxLength: 4,
              minLength: 4,
              min: 1990,
              max: 2021,
            }}
          />
        </div>
        {dobErrors.some(Boolean) && (
          <p className="reg-error" role="alert">
            Enter the full date of birth, for example 04 / 18 / 2015.
          </p>
        )}
      </div>

      <div className="reg-grid reg-grid--3">
        <Field
          as="select"
          name={`${prefix}.gender`}
          label="Singh or Kaur"
          options={[
            { value: "Singh", label: "Singh" },
            { value: "Kaur", label: "Kaur" },
          ]}
          rules={{ ...required, maxLength: 20 }}
        />
        <Field
          as="select"
          name={`${prefix}.grade`}
          label="Grade this school year"
          options={grades}
          rules={{ ...required, maxLength: 20 }}
        />
        <Field
          as="select"
          name={`${prefix}.shirtSize`}
          label="Shirt size"
          options={shirtSizes}
          rules={{ ...required, maxLength: 20 }}
        />
      </div>

      <div className="reg-grid">
        <Field
          as="textarea"
          name={`${prefix}.medicalConditions`}
          label="Medical conditions or allergies"
          rules={{ maxLength: 40000 }}
        />
        <Field
          as="textarea"
          name={`${prefix}.regularMedications`}
          label="Regular medications"
          rules={{ maxLength: 40000 }}
        />
      </div>

      <div className="reg-grid">
        <Field
          name={`${prefix}.doctorsName`}
          label="Doctor's name"
          rules={{ ...required, maxLength: 50 }}
        />
        <Field
          name={`${prefix}.doctorsNumber`}
          label="Doctor's phone number"
          type="tel"
          inputMode="numeric"
          placeholder="3015559999"
          hint="10 digits, numbers only"
          rules={{ ...required, maxLength: 10 }}
        />
      </div>
    </fieldset>
  );
}
